import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('RedeemingAllowanceModel')
export default class RedeemingAllowanceModel {
  @JsonProperty('id', Number, true) public id:number = undefined;
  @JsonProperty('max_price', Number, true) public maxPrice:number = undefined;
}
